import React from "react";
import Services from "./Services";
import { Accordion, AccordionItem } from 'react-light-accordion';
import 'react-light-accordion/demo/css/index.css';
import { log } from "async";

const index = ({ services }) => {
  const groupByServices = getGroupByServices(services)
  const serviceArray = Object.keys(groupByServices).map((item, index) => (
    <AccordionItem title={item} key={index}>
      {groupByServices[item].map((service, key) => {
        return (<Services
          key={index + key}
          name={service.name}
          time={Math.floor(service.duration / 60)}
          price={service.price && service.price != 0 ? service.price : null}
        />)
      })}
    </AccordionItem>
  ));

  return (
    <Accordion atomic={true}>
      {serviceArray}
    </Accordion>
  );
};

const getGroupByServices = (services) => {
  return services.reduce(function (resultArray, service) {
    (resultArray[service.category.name] = resultArray[service.category.name] || []).push(service);
    return resultArray;
  }, {});
};

export default index;



// WEBPACK FOOTER //
// ./components/ServiceBottom/ServicesContainer/index.js